export default __webpack_public_path__ + "static/media/partial.1b227862.svg";